import React from 'react'

export const SectionContainer = ({
  children,
}: {
  children: React.ReactNode
}) => (
  <section className="px-4 md:px-0 py-14 md:py-16 lg:py-18 xl:py-20">
    <div className="container grid grid-cols-1 gap-4 mx-auto md:grid-cols-2">
      {children}
    </div>
  </section>
)
